import { Material } from '@babylonjs/core';

export class MaterialRegistry {
  private materials_ = Array<Material>();

  private indexOfMaterialArray = new Map<Material, number>();

  get materials() {
    return this.materials_;
  }

  getIndex(material: Material) {
    if (this.indexOfMaterialArray.has(material)) {
      return this.indexOfMaterialArray.get(material)!;
    }

    const index = this.materials_.length;
    this.materials_.push(material);
    this.indexOfMaterialArray.set(material, index);
    return index;
  }
}
